import { Layout } from '../../queries/ats/layout/types';
import { Title } from '../../queries/ats/titles/types/title';

export function getSectionLink(items: Layout.SectionItem[]): string | undefined {
  const seeAllBehavior = items.find((item) => item.type === 'page' && item.params?.behavior === 'see-all');
  return seeAllBehavior ? `/${seeAllBehavior.slug}` : undefined;
}

export function titlesToSectionItems(titles: Title[]): Layout.SectionItemTitle[] {
  return titles.map((title) => ({
    id: title.masterId,
    title: title,
    type: 'title',
    slug: title.slug,
    name: '',
    image: '',
    icon: '',
    pageStyle: Layout.PageViewStyleType.SWIMLANE,
    params: null,
  }));
}
